<template>
	<div ref="container" style="height:100%;position:relative;overflow:hidden;"></div>
</template>

<script>
import HighlightedMessageWidget from '@/widgets/HighlightedMessageWidget';

export default {
	name: 'HighlightedMessageWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
		realData: { type: Boolean, default: false },
	},
	data() {
		return { services: [] };
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
		realData() { this._destroyWidget(); this._initWidget(); },
	},
	mounted() {
		this._initWidget();

		this.$api.get('channels')
			.then(channels => {
				const seen = new Set();
				this.services = channels.filter(c => {
					if(!c.service_icon_url || seen.has(c.service_id)) return false;
					seen.add(c.service_id);
					return true;
				});
				if(!this.realData) this._applySettings(this.settings);
			})
			.catch(() => {});
	},
	beforeDestroy() {
		this._destroyWidget();
	},
	methods: {
		async _initWidget() {
			let hash = 'preview';
			if(this.realData) {
				try {
					const user = await this.$api.get('userData');
					if(user?.widget_hash) hash = user.widget_hash;
				} catch(e) { /* ignore */ }
			}

			this.widget = new HighlightedMessageWidget({ container: this.$refs.container });

			this.widget._build();

			const baseCSSElem = document.getElementById('hmBaseCSS');
			if(baseCSSElem) {
				baseCSSElem.textContent = baseCSSElem.textContent
					.replace(/(?:html|body)(?:\s*,\s*(?:html|body))?\s*\{[^}]*\}/g, '');
			}

			this._applySettings(this.settings);

			if(this.realData) {
				this._previewSubId = this.$socket.subscribe(hash, {
					reconnect: () => { this._destroyWidget(); this._initWidget(); },
					messageHighlighted:   msg => this.widget?._handleHighlight(msg),
					messageUnhighlighted: ()  => this.widget?._handleHighlight(null),
				});
			}
		},
		_destroyWidget() {
			this._stopCycle();
			if(this._previewSubId != null) { this.$socket.unsubscribe(this._previewSubId); this._previewSubId = null; }
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},
		_startCycle() {
			this._stopCycle();
			this._cycleStep = 0;
			const MESSAGES = [
				{ id: 'p-chat-1',   type: 'chat',     sender: 'CoolViewer',      spans: [{ text: 'Hey, love the stream!' }] },
				{ id: 'p-gift-1',   type: 'gift',     sender: 'TipperJoe',       spans: [{ text: 'Keep up the great work!' }],          value: 5  },
				{ id: 'p-gift-2',   type: 'gift',     sender: 'BigDonor',        spans: [{ text: 'Amazing stream, keep it up!' }],       value: 50 },
				{ id: 'p-gift-3',   type: 'gift',     sender: 'WhaleSupporter',  spans: [{ text: 'You are the best streamer ever!' }],   value: 100 },
				{ id: 'p-sub-1',    type: 'sub',      sender: 'NewSubscriber',   spans: [] },
				{ id: 'p-follow-1', type: 'follow',   sender: 'FirstTimeViewer', spans: [] },
			];
			const advance = () => {
				if(!this.widget) return;
				const isShow = this._cycleStep % 2 === 0;
				if(isShow) {
					const msg = MESSAGES[Math.floor(this._cycleStep / 2) % MESSAGES.length];
					this.widget._currentMsgId = null;
					this.widget._currentPrepared = null;
					this.widget._handleHighlight(this._buildSampleMessage(msg));
				} else {
					this.widget._handleHighlight(null);
				}
				this._cycleStep++;
				const nextDelay = isShow ? 3000 : 500;
				this._cycleTimer = setTimeout(advance, nextDelay);
			};
			this._cycleTimer = setTimeout(advance, 100);
		},
		_stopCycle() {
			if(this._cycleTimer) { clearTimeout(this._cycleTimer); this._cycleTimer = null; }
		},
		_buildSampleMessage(msg) {
			let serviceId = null, serviceName = null, serviceIconUrl = null;
			if(this.services.length > 0) {
				const svc = this.services[Math.floor(Math.random() * this.services.length)];
				serviceId    = svc.service_id;
				serviceName  = svc.service_name || svc.service_id;
				serviceIconUrl = svc.service_icon_url;
			}
			const isGift = msg.type === 'gift';
			return { message: {
				id: msg.id,
				serviceId, serviceName, serviceIconUrl,
				type: msg.type,
				...(isGift ? { giftType: 'donation', value: msg.value, convertedValue: msg.value, currency: 'USD' } : {}),
				sender: { displayName: msg.sender, avatar: null },
				spans: msg.spans || [],
			}};
		},
		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
			if(!this.realData) {
				this.widget._hiding       = false;
				this.widget._msgElem      = null;
				this.widget._currentMsgId = null;
				this.widget._currentPrepared = null;
				this.widget.widgetElem.innerHTML = '';
				this._startCycle();
			}
		},
	},
};
</script>
